export enum TriggerType {
  Once = 'Once',
  Daily = 'Daily'
}
